module.exports = __webpack_public_path__ + "img/double_arrow_left.0683a5f5.svg";